import isZocdocBrand from '../../utils/isZocdocBrand';

export function isEligibleForUniversalSearchHeaderTest(directoryId, providerIsPreview) {
    return isZocdocBrand(directoryId) && providerIsPreview;
}
